export const style_formats = [
    { title: "제목", block: "h1" },
    { title: "부제목", block: "h2" },
    { title: "본문", block: "p", exact: true },
    { title: "주석", block: 'pre', classes: ["annotation"], exact: true },
    { title: '목록', selector: 'ul,ol', }
]
export const default_conf = {
    menubar: false,
    toolbar:
        "undo redo | styles | color | bold | alignleft aligncenter alignright | __link__ | image",
    plugins: "autoresize lists",
    resize: false,
    statusbar: false,
    height: "auto",
    content_css: "/global.css",
    object_resizing: "img",
    a11y_advanced_options: true,
    resize_img_proportional: true,
    paste_enable_default_filters: false,
    paste_webkit_styles: "color",
    paste_as_text: true,
    body_id: "HITIT-wiswig",
    paste_block_drop: false, // Paste Options
    formats: {
        alignleft: {
            selector: "p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img,audio,video",
            classes: "left",
        },
        aligncenter: {
            selector: "p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img,audio,video",
            classes: "center",
        },
        alignright: {
            selector: "p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img,audio,video",
            classes: "right",
        },
    },
};


// ForeColor 
export const __colors__ = [
    "#333338", "gray6",
    "#46474B", "gray5",
    "#6D6F76", "gray4",
    "#BCBFC3", "gray3",
    "#D8D9DF", "gray2",
    "#E6E7ED", "gray1",
    "#E54848", "red",
    "#10C181", "green",
    "#FFCE00", "yellow",
    "#3C68D6", "blue_dark",
    "#6591FA", "blue_main",
    "#A5C1F9", "blue_light"
]

